module.exports = "/images/vendor/flag-icon-css/flags/4x3/kn.svg?bde74c6da4f2cff6fe3ae84b510b1857";